import { createSelector } from '@reduxjs/toolkit';
import type { RootState } from 'src/datahandling/redux/store';
import type { SignalRLiveState } from './slice';
import { DATA_KEY_SEPARATOR } from '../constants';

export const selectSignalRLiveState = (state: RootState): SignalRLiveState => 
	state.signalRLive;

export const selectConnectionStatus = createSelector(
	[selectSignalRLiveState],
	(state) => state.connectionStatus
);

export const selectConnectionId = createSelector(
	[selectSignalRLiveState],
	(state) => state.connectionId
);

export const selectLastError = createSelector(
	[selectSignalRLiveState],
	(state) => state.lastError
);

export const selectIsConnected = createSelector(
	[selectConnectionStatus],
	(status) => status === 'connected'
);

export const selectAllSensorData = createSelector(
	[selectSignalRLiveState],
	(state) => state.sensorData
);

export const selectUnitSensorData = createSelector(
	[selectAllSensorData, (_state: RootState, unitId: number) => unitId],
	(allData, unitId) => allData[unitId] ?? {}
);

export const selectSensorValue = createSelector(
	[
		selectAllSensorData,
		(_state: RootState, params: { unitId: number; dataType: string; measurement: string }) => params,
	],
	(allData, { unitId, dataType, measurement }) => {
		const unitData = allData[unitId];
		if (!unitData) return null;

		const dataKey = `${dataType}${DATA_KEY_SEPARATOR}${measurement}`;
		return unitData[dataKey] ?? null;
	}
);

export const selectUnitsWithData = createSelector(
	[selectAllSensorData],
	(allData) => Object.keys(allData).map(Number)
);

export const selectUnitCount = createSelector(
	[selectUnitsWithData],
	(units) => units.length
);

